/**
 * MUSKLE Hero 05 — Shopify section
 * Asset URLs resolved via Liquid. Safe init/destroy for theme editor.
 */
(function () {
  'use strict';

  if (window.MuskleHero05 && window.MuskleHero05.__ready) return;

  var ASSETS = {
    hydrateLifestyle: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-hydrate-lifestyle.png?v=114535385739414715931790615305",
    proteinPancakeLifestyle: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-protein-pancake-lifestyle.png?v=910988170530223161790615314",
    number02Replacement: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-number-02-replacement.jpeg?v=125863894472737043241790615312",
    mg33: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-mg33.png?v=170558085202377103241790615310",
    hydroGoldLifestyle: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-hydro-gold-lifestyle.png?v=43142957937225533721790615307",
    creatineGummiesLifestyle: "\/\/muskle.com\/cdn\/shop\/t\/21\/assets\/muskle-hero-05-creatine-gummies-lifestyle.png?v=156965896047025976101790615303"
  };

  var taglineItems = [
    { lead: 'Perform', accent: 'better' },
    { lead: 'Train', accent: 'harder' },
    { lead: 'Recover', accent: 'smarter' },
    { lead: 'Fuel your', accent: 'power' },
    { lead: 'Push', accent: 'further' },
    { lead: 'Build', accent: 'strength' },
    { lead: 'Go', accent: 'beyond' }
  ];

  var PANEL_ENTRANCE_MS = 1600;
  var PANEL_STAGGER_MS = 220;
  var PANEL_ENTRANCE_DELAY_MS = 400;
  var LOGO_REVEAL_DELAY_MS = 1200;
  var TAGLINE_START_DELAY_MS = 2200;
  var showTrustBadges = false;
  var showHero02Numbers = false;

  var hero02ReviewNumbers = {
    'left-lifestyle': 1,
    'pancake-lifestyle': 6
  };

  var hero02ImageSwaps = [];
  var IMAGE_SWAP_DURATION_MS = 5200;

  var PANEL_CROSSFADE_MS = 2200;
  var PANEL_ALT_HOLD_MS = 5200;
  var PANEL_SEQUENCE_PAUSE_MS = 1000;
  var PANEL_LOOP_START_DELAY_MS = 2800;

  var HERO05_MOTION_GAP_MS = 1400;

  var hero05MotionCoordinator =
    window.__muskleHero05MotionCoordinator ||
    (window.__muskleHero05MotionCoordinator = (function () {
      var queue = Promise.resolve();

      function waitGap(ms) {
        return new Promise(function (resolve) {
          setTimeout(resolve, ms);
        });
      }

      function schedule(label, job) {
        var nextJob = queue
          .catch(function () {})
          .then(function () {
            return waitGap(HERO05_MOTION_GAP_MS);
          })
          .then(function () {
            return job();
          });

        queue = nextJob.catch(function () {});
        return nextJob;
      }

      return {
        schedule: schedule
      };
    })());

  var instances = new Map();

  function buildMedia() {
    return [
      {
        id: 'left-lifestyle',
        type: 'image',
        src: ASSETS.hydrateLifestyle,
        fit: 'cover',
        focus: 'center center',
        role: 'poster',
        energy: 'red'
      },
      {
        id: 'pancake-lifestyle',
        type: 'image',
        src: ASSETS.proteinPancakeLifestyle,
        fit: 'cover',
        focus: 'center center',
        role: 'poster',
        energy: 'blue'
      }
    ];
  }

  function buildPanelLoopAlts() {
    return {
      'left-lifestyle': [ASSETS.number02Replacement, ASSETS.mg33],
      'pancake-lifestyle': [ASSETS.hydroGoldLifestyle, ASSETS.creatineGummiesLifestyle]
    };
  }

  function createController(root) {
    var hero = root.querySelector('.hero-02');
    var collageEl = root.querySelector('[data-hero05-collage]');
    var taglineEl = root.querySelector('[data-hero05-tagline]');
    var trustEl = root.querySelector('[data-hero05-trust]');
    if (!hero || !collageEl || !taglineEl) return null;

    var hero02Media = buildMedia();
    var PANEL_LOOP_ALTS = buildPanelLoopAlts();
    var timers = [];
    var observers = [];
    var resizeHandler = null;
    var resizeObserver = null;
    var scaleRaf = null;
    var destroyed = false;
    var loopGeneration = 0;

    function trackTimeout(fn, ms) {
      var id = setTimeout(function () {
        if (destroyed) return;
        fn();
      }, ms);
      timers.push(id);
      return id;
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        trackTimeout(resolve, ms);
      });
    }

    if (!showTrustBadges) {
      hero.classList.add('hero-02--no-trust');
      if (trustEl) trustEl.hidden = true;
    } else if (trustEl) {
      trustEl.hidden = false;
    }

    root.style.setProperty('--logo-delay', LOGO_REVEAL_DELAY_MS + 'ms');
    root.style.setProperty('--tagline-delay', TAGLINE_START_DELAY_MS + 'ms');
    root.style.setProperty('--promo-delay', TAGLINE_START_DELAY_MS + 400 + 'ms');
    root.style.setProperty('--tagline-transition', PANEL_CROSSFADE_MS / 1000 + 's');
    root.style.setProperty('--panel-crossfade', PANEL_CROSSFADE_MS / 1000 + 's');

    Object.keys(PANEL_LOOP_ALTS).forEach(function (id) {
      PANEL_LOOP_ALTS[id].forEach(function (src) {
        var preload = new Image();
        preload.src = src;
      });
    });

    function getImageSwap(item) {
      return hero02ImageSwaps.find(function (swap) {
        return swap.targetId === item.id;
      });
    }

    function appendSwapOverlay(parent, item, swap) {
      var overlay = document.createElement('img');
      overlay.className = 'hero-02__media hero-02__media--swap';
      if (item.type === 'video') {
        overlay.classList.add('hero-02__sim-video__poster');
      } else {
        overlay.classList.add('hero-02__media--image');
      }
      overlay.src = swap.replacementSrc;
      overlay.alt = '';
      overlay.loading = 'eager';
      overlay.decoding = 'async';
      applyMediaStyles(overlay, item);
      parent.appendChild(overlay);
    }

    function applyMediaStyles(el, item) {
      if (item.fit) el.style.objectFit = item.fit;
      if (item.focus) el.style.objectPosition = item.focus;
    }

    function buildSweep() {
      var sweep = document.createElement('span');
      sweep.className = 'hero-02__layer-sweep';
      sweep.setAttribute('aria-hidden', 'true');
      return sweep;
    }

    function appendLoopOverlay(wrap, item, altSrc, index) {
      var overlay = document.createElement('img');
      overlay.className = 'hero-02__media hero-02__media--image hero-02__media--loop-alt';
      overlay.src = altSrc;
      overlay.alt = '';
      overlay.loading = 'eager';
      overlay.decoding = 'async';
      overlay.dataset.loopIndex = String(index);
      overlay.style.zIndex = String(2 + index);
      applyMediaStyles(overlay, item);
      wrap.appendChild(overlay);
    }

    function buildImageContent(item) {
      var wrap = document.createElement('div');
      wrap.className = 'hero-02__media-wrap';
      if (item.role === 'cutout' || item.fit === 'contain') {
        wrap.classList.add('hero-02__media-wrap--cutout');
      }

      var img = document.createElement('img');
      img.className = 'hero-02__media hero-02__media--image';
      img.alt = '';
      img.src = item.src;
      img.loading =
        item.id === 'left-lifestyle' || item.id === 'pancake-lifestyle' ? 'eager' : 'lazy';
      img.decoding = 'async';
      applyMediaStyles(img, item);
      wrap.appendChild(img);

      var alts = PANEL_LOOP_ALTS[item.id];
      if (alts && alts.length) {
        wrap.classList.add('hero-02__media-wrap--loop');
        alts.forEach(function (src, index) {
          appendLoopOverlay(wrap, item, src, index);
        });
      }

      var swap = getImageSwap(item);
      if (swap) {
        wrap.classList.add('hero-02__media-wrap--swap');
        appendSwapOverlay(wrap, item, swap);
      }

      return wrap;
    }

    function buildLayer(item, index) {
      var layer = document.createElement('article');
      layer.className =
        'hero-02__layer hero-02__layer--' +
        item.id +
        ' hero-02__layer--' +
        (item.role || 'poster');
      layer.dataset.layer = item.id;
      layer.style.animationDelay =
        PANEL_ENTRANCE_DELAY_MS + index * PANEL_STAGGER_MS + 'ms';
      layer.style.setProperty('--float-delay', index * 0.65 + 's');

      var clip = document.createElement('div');
      clip.className = 'hero-02__layer-clip';

      var inner = document.createElement('div');
      inner.className = 'hero-02__layer-inner';

      var mediaWrap = buildImageContent(item);
      inner.appendChild(mediaWrap);
      inner.appendChild(buildSweep());

      var edge = document.createElement('span');
      edge.className = 'hero-02__layer-edge';
      edge.setAttribute('aria-hidden', 'true');
      inner.appendChild(edge);

      clip.appendChild(inner);
      layer.appendChild(clip);

      if (showHero02Numbers && hero02ReviewNumbers[item.id]) {
        var badge = document.createElement('span');
        badge.className = 'hero-02__debug-number';
        badge.textContent = String(hero02ReviewNumbers[item.id]);
        badge.setAttribute('data-number', String(hero02ReviewNumbers[item.id]));
        badge.setAttribute('aria-hidden', 'true');
        layer.appendChild(badge);
      }

      return layer;
    }

    function buildCollage() {
      collageEl.innerHTML = '';
      hero02Media.forEach(function (item, index) {
        collageEl.appendChild(buildLayer(item, index));
      });
    }

    function applyTaglineItem(index) {
      var line = taglineEl.querySelector('.hero-02__tagline-line');
      if (!line) return;
      var item = taglineItems[index];
      line.querySelector('.hero-02__tagline-lead').textContent = item.lead + ' ';
      var accent = line.querySelector('.hero-02__tagline-accent');
      accent.textContent = item.accent;
      var accentTone = index % 2 === 0 ? 'red' : 'blue';
      accent.className =
        'hero-02__tagline-accent tagline-last-word tagline-last-word--' + accentTone;
    }

    function buildTaglines() {
      taglineEl.innerHTML = '';

      var line = document.createElement('p');
      line.className = 'hero-02__tagline-line hero-02__tagline-line--intro';

      var lead = document.createElement('span');
      lead.className = 'hero-02__tagline-lead';

      var accent = document.createElement('span');
      accent.className = 'hero-02__tagline-accent';

      line.appendChild(lead);
      line.appendChild(accent);
      taglineEl.appendChild(line);

      applyTaglineItem(0);

      trackTimeout(function () {
        line.classList.remove('hero-02__tagline-line--intro');
        line.classList.add('hero-02__tagline-line--active');
      }, TAGLINE_START_DELAY_MS + 1000);
    }

    function initLayerEntrance() {
      var layers = hero.querySelectorAll('.hero-02__layer');
      var doneAt =
        PANEL_ENTRANCE_DELAY_MS + layers.length * PANEL_STAGGER_MS + PANEL_ENTRANCE_MS;

      layers.forEach(function (layer) {
        layer.addEventListener('animationend', function onEnd(e) {
          if (e.animationName === 'layerEnter') {
            layer.classList.add('hero-02__layer--live');
            layer.removeEventListener('animationend', onEnd);
          }
        });
      });

      trackTimeout(function () {
        layers.forEach(function (l) {
          l.classList.add('hero-02__layer--live');
        });
      }, doneAt);
    }

    function initImageSwaps() {
      if (!hero02ImageSwaps.length) return;

      root.style.setProperty('--image-swap-duration', IMAGE_SWAP_DURATION_MS / 1000 + 's');

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      hero02ImageSwaps.forEach(function (swap) {
        trackTimeout(function () {
          var wrap = hero.querySelector(
            '.hero-02__layer--' + swap.targetId + ' .hero-02__media-wrap--swap'
          );
          if (!wrap) return;

          if (prefersReduced) {
            wrap.classList.add('hero-02__media-wrap--swap-complete');
            return;
          }

          wrap.classList.add('hero-02__media-wrap--swap-active');
        }, swap.delay);
      });
    }

    function initMasterTimeline() {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      var leftAlts = hero.querySelectorAll(
        '.hero-02__layer--left-lifestyle .hero-02__media--loop-alt'
      );
      var rightAlts = hero.querySelectorAll(
        '.hero-02__layer--pancake-lifestyle .hero-02__media--loop-alt'
      );
      if (!leftAlts.length || !rightAlts.length) return;

      var taglineIndex = 0;
      var generation = ++loopGeneration;

      function hideAll(alts) {
        alts.forEach(function (el) {
          el.classList.remove('is-visible');
        });
      }

      function showAltIndex(alts, index) {
        var next = alts[index];
        if (!next) return wait(0);
        next.classList.add('is-visible');
        return wait(PANEL_CROSSFADE_MS).then(function () {
          alts.forEach(function (el, i) {
            if (i !== index) el.classList.remove('is-visible');
          });
        });
      }

      function returnToBase(alts) {
        hideAll(alts);
        return wait(PANEL_CROSSFADE_MS);
      }

      function syncedChange(imageOp) {
        var line = taglineEl.querySelector('.hero-02__tagline-line');
        if (line) {
          line.classList.remove(
            'hero-02__tagline-line--intro',
            'hero-02__tagline-line--active'
          );
          line.classList.add('hero-02__tagline-line--exit');
        }

        return imageOp().then(function () {
          if (destroyed || generation !== loopGeneration) return;
          taglineIndex = (taglineIndex + 1) % taglineItems.length;
          applyTaglineItem(taglineIndex);
          if (line) {
            line.classList.remove('hero-02__tagline-line--exit');
            line.classList.add('hero-02__tagline-line--active');
          }
        });
      }

      var leftState = -1;
      var rightState = -1;

      function advancePanel(alts, currentState) {
        var nextState = currentState + 1;

        if (nextState < alts.length) {
          return hero05MotionCoordinator
            .schedule('main-hero', function () {
              return syncedChange(function () {
                return showAltIndex(alts, nextState);
              });
            })
            .then(function () {
              return wait(PANEL_ALT_HOLD_MS);
            })
            .then(function () {
              return nextState;
            });
        }

        return hero05MotionCoordinator
          .schedule('main-hero', function () {
            return syncedChange(function () {
              return returnToBase(alts);
            });
          })
          .then(function () {
            return wait(PANEL_ALT_HOLD_MS);
          })
          .then(function () {
            return -1;
          });
      }

      function runAlternatingLoop() {
        if (destroyed || generation !== loopGeneration) return Promise.resolve();

        return advancePanel(leftAlts, leftState)
          .then(function (newLeftState) {
            if (destroyed || generation !== loopGeneration) return;
            leftState = newLeftState;
            return wait(PANEL_SEQUENCE_PAUSE_MS);
          })
          .then(function () {
            if (destroyed || generation !== loopGeneration) return;
            return advancePanel(rightAlts, rightState);
          })
          .then(function (newRightState) {
            if (destroyed || generation !== loopGeneration) return;
            rightState = newRightState;
            return wait(PANEL_SEQUENCE_PAUSE_MS);
          })
          .then(runAlternatingLoop);
      }

      trackTimeout(function () {
        runAlternatingLoop();
      }, PANEL_LOOP_START_DELAY_MS);
    }

    function initStageScale() {
      var stage = hero.querySelector('.hero-05__stage');
      if (!stage) return;

      var DESIGN_W = 1920;
      var lastScale = null;

      function updateScale() {
        if (destroyed) return;
        var width = hero.clientWidth || window.innerWidth;
        var scale = width / DESIGN_W;
        if (!isFinite(scale) || scale <= 0) scale = 1;

        /* Skip no-op writes — mobile chrome resize noise must not restyle the stage */
        if (lastScale !== null && Math.abs(scale - lastScale) < 0.0005) return;
        lastScale = scale;
        hero.style.setProperty('--hero-05-scale', String(scale));
      }

      function scheduleUpdateScale() {
        if (scaleRaf !== null) return;
        scaleRaf = window.requestAnimationFrame(function () {
          scaleRaf = null;
          updateScale();
        });
      }

      updateScale();
      resizeHandler = scheduleUpdateScale;
      window.addEventListener('resize', resizeHandler, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(scheduleUpdateScale);
        resizeObserver.observe(hero);
      }
    }

    buildCollage();
    buildTaglines();
    initLayerEntrance();
    initImageSwaps();
    initMasterTimeline();
    initStageScale();

    var audienceController = initAudienceBanner(root);

    return {
      destroy: function () {
        destroyed = true;
        loopGeneration += 1;
        timers.forEach(function (id) {
          clearTimeout(id);
        });
        timers.length = 0;
        if (resizeHandler) {
          window.removeEventListener('resize', resizeHandler);
          resizeHandler = null;
        }
        if (scaleRaf !== null && typeof window.cancelAnimationFrame === 'function') {
          window.cancelAnimationFrame(scaleRaf);
          scaleRaf = null;
        }
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
        observers.forEach(function (obs) {
          obs.disconnect();
        });
        observers.length = 0;
        collageEl.innerHTML = '';
        taglineEl.innerHTML = '';
        if (audienceController && audienceController.destroy) {
          audienceController.destroy();
          audienceController = null;
        }
      }
    };
  }

  function initAudienceBanner(rootOrBanner) {
    if (!rootOrBanner) return null;
    var banner =
      rootOrBanner.matches && rootOrBanner.matches('[data-muskle-audience-banner]')
        ? rootOrBanner
        : rootOrBanner.querySelector
          ? rootOrBanner.querySelector('[data-muskle-audience-banner]')
          : null;
    if (!banner) return null;

    if (banner.__muskleAudienceController && banner.__muskleAudienceController.destroy) {
      banner.__muskleAudienceController.destroy();
    }

    var AUDIENCE_HOLD_MS = 7200;
    var AUDIENCE_CROSSFADE_MS = 3200;
    var AUDIENCE_START_DELAY_MS = 6500;

    var images = banner.querySelectorAll('.muskle-hero-05__audience-image');
    if (!images.length) return null;

    var activePair = 0;
    var audienceTimer = null;
    var audienceDestroyed = false;
    var pageHidden = false;

    function waitMs(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function doubleAnimationFrame() {
      return new Promise(function (resolve) {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      });
    }

    function getPairImages(pairIndex) {
      return Array.prototype.slice.call(
        banner.querySelectorAll(
          '.muskle-hero-05__audience-image[data-audience-pair="' +
            String(pairIndex) +
            '"]'
        )
      );
    }

    function decodeImage(img) {
      if (img.complete && img.naturalWidth > 0) {
        if (typeof img.decode === 'function') {
          return img.decode().catch(function () {});
        }
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        img.addEventListener(
          'load',
          function () {
            if (typeof img.decode === 'function') {
              img.decode().catch(function () {}).then(resolve);
            } else {
              resolve();
            }
          },
          { once: true }
        );
        img.addEventListener('error', resolve, { once: true });
      });
    }

    function decodeAllAudienceImages() {
      return Promise.all(
        Array.prototype.map.call(images, function (img) {
          return decodeImage(img);
        })
      );
    }

    function setInitialPair() {
      getPairImages(0).forEach(function (img) {
        img.classList.add('is-active');
        img.classList.remove('is-incoming', 'is-outgoing');
      });
      getPairImages(1).forEach(function (img) {
        img.classList.remove('is-active', 'is-incoming', 'is-outgoing');
      });
      activePair = 0;
    }

    function crossfadeToPair(nextPairIndex) {
      if (audienceDestroyed) return Promise.resolve();

      var outgoingImages = getPairImages(activePair);
      var incomingImages = getPairImages(nextPairIndex);

      return Promise.all(
        incomingImages.map(function (img) {
          return decodeImage(img);
        })
      )
        .then(function () {
          if (audienceDestroyed) return;
          incomingImages.forEach(function (img) {
            img.classList.add('is-incoming');
            img.classList.remove('is-active');
          });
          outgoingImages.forEach(function (img) {
            img.classList.add('is-outgoing');
          });
          return doubleAnimationFrame();
        })
        .then(function () {
          if (audienceDestroyed) return;
          incomingImages.forEach(function (img) {
            img.classList.add('is-active');
          });
          outgoingImages.forEach(function (img) {
            img.classList.remove('is-active');
          });
          return waitMs(AUDIENCE_CROSSFADE_MS + 120);
        })
        .then(function () {
          if (audienceDestroyed) return;
          outgoingImages.forEach(function (img) {
            img.classList.remove('is-outgoing');
          });
          incomingImages.forEach(function (img) {
            img.classList.remove('is-incoming');
          });
          activePair = nextPairIndex;
        });
    }

    function clearAudienceTimer() {
      if (audienceTimer) {
        clearTimeout(audienceTimer);
        audienceTimer = null;
      }
    }

    function scheduleNextAudienceChange() {
      if (audienceDestroyed || pageHidden) return;

      clearAudienceTimer();
      audienceTimer = setTimeout(function () {
        if (audienceDestroyed || pageHidden) return;

        var nextPair = activePair === 0 ? 1 : 0;

        hero05MotionCoordinator
          .schedule('audience-banner', function () {
            return crossfadeToPair(nextPair);
          })
          .then(function () {
            scheduleNextAudienceChange();
          })
          .catch(function () {
            scheduleNextAudienceChange();
          });
      }, AUDIENCE_HOLD_MS);
    }

    setInitialPair();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var reduced = {
        destroy: function () {
          audienceDestroyed = true;
          clearAudienceTimer();
        }
      };
      banner.__muskleAudienceController = reduced;
      return reduced;
    }

    function onVisibilityChange() {
      if (document.hidden) {
        pageHidden = true;
        clearAudienceTimer();
        return;
      }

      pageHidden = false;
      if (audienceDestroyed) return;
      clearAudienceTimer();
      audienceTimer = setTimeout(function () {
        scheduleNextAudienceChange();
      }, AUDIENCE_HOLD_MS);
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    decodeAllAudienceImages().then(function () {
      if (audienceDestroyed) return;
      audienceTimer = setTimeout(function () {
        scheduleNextAudienceChange();
      }, AUDIENCE_START_DELAY_MS);
    });

    var controller = {
      destroy: function () {
        audienceDestroyed = true;
        clearAudienceTimer();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (banner.__muskleAudienceController === controller) {
          delete banner.__muskleAudienceController;
        }
      }
    };

    banner.__muskleAudienceController = controller;
    return controller;
  }

  function getSectionRoot(el) {
    if (!el) return null;
    if (el.matches && el.matches('[data-muskle-hero-05]')) return el;
    return el.querySelector ? el.querySelector('[data-muskle-hero-05]') : null;
  }

  function initRoot(root) {
    if (!root || !root.id) return;
    if (instances.has(root.id)) {
      instances.get(root.id).destroy();
      instances.delete(root.id);
    }
    var controller = createController(root);
    if (controller) instances.set(root.id, controller);
  }

  function destroyRoot(root) {
    if (!root || !root.id) return;
    var controller = instances.get(root.id);
    if (controller) {
      controller.destroy();
      instances.delete(root.id);
    }
  }

  function initStandaloneAudienceBanners(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-muskle-audience-banner]').forEach(function (banner) {
      /* Hero roots already init audience via createController */
      if (banner.closest('[data-muskle-hero-05]')) return;
      initAudienceBanner(banner);
    });
  }

  var HOMEPAGE_PROMO_START_FALLBACK = '2026-09-15T09:00:00+02:00';
  var HOMEPAGE_PROMO_END_FALLBACK = '2026-09-22T00:00:00+02:00';
  var MAX_TIMEOUT_MS = 2147483647;

  function hideHomepagePromo(root) {
    if (!root) return;
    root.querySelectorAll('[data-hero05-promo], [data-hero05-promo-strip]').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      if (el.getAttribute('href') && !el.getAttribute('data-promo-href')) {
        el.setAttribute('data-promo-href', el.getAttribute('href'));
      }
      el.removeAttribute('href');
      el.setAttribute('tabindex', '-1');
      el.style.pointerEvents = 'none';
    });
    root.classList.remove('muskle-hero-05-section--home-promo');
    root.classList.add('is-homepage-promo-off');
  }

  function showHomepagePromo(root) {
    if (!root) return;
    root.querySelectorAll('[data-hero05-promo], [data-hero05-promo-strip]').forEach(function (el) {
      var href = el.getAttribute('data-promo-href');
      if (href) el.setAttribute('href', href);
      el.hidden = false;
      el.removeAttribute('aria-hidden');
      el.removeAttribute('tabindex');
      el.style.pointerEvents = '';
    });
    root.classList.add('muskle-hero-05-section--home-promo');
    root.classList.remove('is-homepage-promo-off');
    root.classList.remove('is-creatine-promo-expired');
  }

  function armHomepagePromoWindow(root) {
    if (!root || root.__muskleHomepagePromoArmed) return;
    if (
      !root.hasAttribute('data-homepage-promo-start') &&
      !root.hasAttribute('data-homepage-promo-end') &&
      !root.hasAttribute('data-creatine-promo-end')
    ) {
      return;
    }
    root.__muskleHomepagePromoArmed = true;

    var startIso = root.getAttribute('data-homepage-promo-start') || HOMEPAGE_PROMO_START_FALLBACK;
    var endIso =
      root.getAttribute('data-homepage-promo-end') ||
      root.getAttribute('data-creatine-promo-end') ||
      HOMEPAGE_PROMO_END_FALLBACK;
    var startMs = Date.parse(startIso) || 0;
    var endMs = Date.parse(endIso);
    if (!endMs) return;

    function apply() {
      var now = Date.now();
      if (now >= startMs && now < endMs) showHomepagePromo(root);
      else hideHomepagePromo(root);
    }

    apply();

    var now = Date.now();
    if (startMs > now) {
      setTimeout(apply, Math.min(startMs - now + 50, MAX_TIMEOUT_MS));
    }
    if (endMs > now) {
      setTimeout(apply, Math.min(endMs - now + 50, MAX_TIMEOUT_MS));
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) apply();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-muskle-hero-05]').forEach(function (root) {
      initRoot(root);
      armHomepagePromoWindow(root);
    });
    initStandaloneAudienceBanners(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = getSectionRoot(event.target);
    if (root) {
      initRoot(root);
      armHomepagePromoWindow(root);
    }
    initStandaloneAudienceBanners(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = getSectionRoot(event.target);
    if (root) destroyRoot(root);
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-muskle-audience-banner]').forEach(function (banner) {
        if (banner.__muskleAudienceController && banner.__muskleAudienceController.destroy) {
          banner.__muskleAudienceController.destroy();
        }
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.MuskleHero05 = {
    __ready: true,
    init: initRoot,
    destroy: destroyRoot,
    initAll: initAll
  };
})();
